import moment from "moment";
import React, { useRef, useState } from "react";
import ToolTip from "../../common/ToolTip/ToolTip";
import SMSModal from "../../common/Modal/SMSModal";
import EmailModal from "../../common/Modal/EmailModal";
import { fetchVariableDetails, getCallHistory, getEmailDetails, getSMSDetails, sendAllEmailbtn, sendAllSmsbtn, sendEmail, sendSMS } from "../action";
import { useDispatch } from "react-redux";
import useConfiguration from "../../../hooks/useConfiguration";
import CallModal from "../../common/Modal/CallModal";
import { toast } from "react-toastify";
import '../index.css'
import useSessionStorage from "../../../hooks/useSessionStorage";
import { payRateTypeObj } from "../../../helpers/data";
import { useOutsideClick } from "../../../hooks/useOutsideClick";

const SingleShiftClaimInfo = (props) => {
  const config = useConfiguration();
  const dispatch = useDispatch();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  // SMS state 
  const [smsModalInd, setSmsModalInd] = useState(false);
  const [smsModalData, setSmsModalData] = useState({});
  const [smsModalGetData, setSmsModalGetData] = useState({ sms: "" });
  const [smsModalList, setSmsModalList] = useState([]);
  const [candidateName, setCandidateName] = useState('');
  // Email state
  const [emailModalInd, setEmailModalInd] = useState(false);
  const [emailModalData, setEmailModalData] = useState([]);
  const [emailModalGetData, setEmailModalGetData] = useState({ subject: "" });
  const [emailModalList, setEmailModalList] = useState([]);

  // Call state
  const [callModalInd, setCallModalInd] = useState(false);
  const [callModalData, setCallModalData] = useState([]);
  const [callModalGetData, setCallModalGetData] = useState({ subject: "" });
  const [callModalList, setCallModalList] = useState([]);
  const [callParams, setCallParams] = useState("");

  const { claimedCandidateInfo, jobTitle } = props;
  const shiftHoursCalc = (time) => {
    let shiftHours = "";
    const hours = Math.floor(parseInt(time) / 60);
    const minutes = parseInt(time) % 60;
    if (hours) {
      shiftHours += `${hours} ${parseInt(hours) === 1 ? "hr " : "hrs "}`;
    }
    if (minutes) {
      shiftHours += `${minutes} mins`;
    }
    return shiftHours;
  };
  const VariablePayRateTable = (
    <table className="table table-responsive">
      <thead>
        <tr>
          <th className="text-capitalize">Start Time</th>
          <th className="text-capitalize">End Time</th>
          <th className="text-capitalize">Mark Up</th>
        </tr>
      </thead>
      <tbody>
        {
          claimedCandidateInfo?.payRates?.map((item, index) => {
            return (
              <tr className="border-bottom mt-2 bg-white">
                <td>{moment(item?.shiftStartTime, "hh:mm").format("hh:mm A")}</td>
                <td>{moment(item?.shiftEndTIme, "hh:mm").format("hh:mm A")}</td>
                <td>{item?.markup ? item?.markup : ''}</td>
              </tr>
            )
          })
        }
      </tbody>
    </table>
  )
  // SMS Show modal box
  const showSmsModal = async (data) => {
  //   const fistname = data?.candidateFirstName
  //   ? data?.candidateFirstName
  //   : "";
  // const lastName = data?.candidateLastName
  //   ? data?.candidateLastName
  //   : "";
  // const displayname = fistname + " " + lastName;
  const displayname = data?.candidateName ?? "";
  setCandidateName(displayname);
    if (smsModalInd) {
      setSmsModalList([]);
    } else {
      if(!!login?.verifiedPhoneNumber){
        const params = {
          candidateUniqueId:data?.candidateUniqueId,
          employerMobileNumber:login.verifiedPhoneNumber,
          candidateMobileNumber:`${login.countryPhoneCode}${(data?.cellPhoneNumber).replace(/-/g, '')}`
        }
        const smsDetailsResult = await dispatch(
          getSMSDetails({
            url: `${config.baseUrl}/Messaging/get-sms-messages`,params
          }),
        );
        setSmsModalList(smsDetailsResult);
      } else {
        toast.error("SMS faciality not mapped to this employer.")
        return
      }
    }
    getSmsModalData("sms", "");
    setSmsModalData(data);
    setSmsModalInd((preVal) => !preVal);
  };

  // SMS modal box data
  const getSmsModalData = (index, value) => {
    setSmsModalGetData((preVal) => {
      return {
        ...preVal,
        [index]: value,
      };
    });
  };

  // SMS save modal box
  const saveSmsModal = async () => {
    const requestBody = {
      candidateUniqueId: smsModalData.candidateUniqueId,
      messageBody: smsModalGetData.sms,
    };
    await dispatch(
      sendSMS({
        url: `${config.baseUrl}/Messaging/send-sms-to-candidate`,
        params: requestBody,
      }),
    );
    showSmsModal();
  };

  // Email Modal 
  const showEmailModal = async (data) => {
    getEmailModalData("subject", "");
    if (emailModalInd) {
      setEmailModalList([]);
    } else {
      const emailDetailsResult = await dispatch(
        getEmailDetails({
          url: `${config.baseUrl}/Messaging/get-email-messages/${data.candidateUniqueId}`,
        }),
      );
      if (Array.isArray(emailDetailsResult) && emailDetailsResult?.length) setEmailModalList(emailDetailsResult);
    }
    setEmailModalData((preVal) => [data]);
    setEmailModalInd((preVal) => !preVal);
  };

  // Email modal data
  const getEmailModalData = (index, value) => {
    setEmailModalGetData((preVal) => {
      return {
        ...preVal,
        [index]: value,
      };
    });
  };

  // Email save function
  const saveEmailModal = async (sessionUniqueId) => {
    const description = window.emailSummaryNoteValue();
    if(emailModalGetData.subject && description) {
    const requestBody = {
      candidateUniqueId: valueJoinWithComma(
        emailModalData,
        "candidateUniqueId",
      ),
      emailSubject: emailModalGetData.subject,
      messageBody: description,
      sessionId :sessionUniqueId,
      employerUniqueId : login?.employerUniqueId,
    };
    await dispatch(
      sendEmail({
        url: `${config.baseUrl}/Messaging/send-email-to-candidate`,
        params: requestBody,
      }),
    );
    showEmailModal();
    }else {
      toast.error('Subject field is required')
    }
  };

  // Showing value
  const valueJoinWithComma = (inputValue, key) => {
    let returnValue = "";
    if (!inputValue) return returnValue;
    if (!key) {
      returnValue = inputValue.join(",");
    } else {
      returnValue = inputValue.map((e) => e[key]).join(",");
    }
    return returnValue;
  };

  // Send ALL Email 
  const sendAllEmail = () => {
    dispatch(
      sendAllEmailbtn(`${config.baseMailUrl}/Messaging/sendallemails`),
    ).then((res) => {
      if(res.status === 200){
        toast.success('Email sent successfully!')
      } else {
        toast.error('Email Not sent!')
      }
    })
    showEmailModal();
  };

    // Email Read
    const sendReadEmail =  () => {
      if(config.baseUrl) {
        dispatch(sendAllEmailbtn(`${config.baseMailUrl}/Email/email-read-by-Graph`))
        .then((res) => {
          if(res.status === 200){
            toast.success('Employer Email details updated successfully')
          } else {
            toast.error('Employer Email details are not updated')
          }
        })
      };
        showEmailModal();
     };

  // Send ALL SMS
  const sendAllSms = () => {
      dispatch(
      sendAllSmsbtn('https://development.overturexl.com/DevMessagingApi/api/Messaging/sendSMS')
    );
    showSmsModal();
  };

  // Call Modal 
  const showCallModal = async (data) => {
    if (callModalInd) {
      setCallModalList([]);
    } else {
      const params = {
        phoneNumber: `${login.countryPhoneCode}${(data.cellPhoneNumber).replace(/-/g, '')}`
      }
      dispatch(getCallHistory(config.baseUrl, params)).then((callDetailsResult) => {
        if (Array.isArray(callDetailsResult) && callDetailsResult?.length) setCallModalList(callDetailsResult);
      })
      setCallParams({
        phoneNumber: data.cellPhoneNumber,
        candidateUniqueId : data.candidateUniqueId,
        jobsShiftUniqueId: 0,
        jobsClaimId: 0
      });
    }
    setCallModalData((preVal) => [data]);
    setCallModalInd((preVal) => !preVal);
  };

  // Once hangUP the Call that time Call History API Updated
  const getCallHistoryList = (phone) => {
    const params = {
      phoneNumber: `${(phone).replace(/-/g, '')}`
    }
    dispatch(getCallHistory(config.baseUrl, params)).then((callDetailsResult) => {
      if (Array.isArray(callDetailsResult) && callDetailsResult?.length) setCallModalList(callDetailsResult);
    })
  }

  const variableRef = useRef(null);
  const [variableOpen, setVariableOpen] = useState({status: false, data: []});
  const [variableEmpBaseOpen, setVariableEmpBaseOpen] = useState({status: false, data: []})

  const getVariableDetails = (data, isCandiate) => {
    const params = {
      jobPaymentId: 0,
      claimId: data?.jobsClaimId
    }

      dispatch(fetchVariableDetails(`${config.baseUrl}/CandidatesJobs/payrate-for-viewsummary`, params))
        .then(response => {
          isCandiate ? setVariableOpen({status: true, data: response?.candidateHourlyPayratesViewList}) 
          : setVariableEmpBaseOpen({status: true, data: response?.employerHourlyPayratesViewList})
      })
  }

  const handleOutsideClick = () => {
    setVariableOpen({ status: false,  data: [] })
    setVariableEmpBaseOpen({ status: false,  data: [] })
  };
  useOutsideClick(variableRef, handleOutsideClick);

  return (
    <>
      <EmailModal
        showModal={emailModalInd}
        handleClose={showEmailModal}
        data={emailModalData}
        handleSave={saveEmailModal}
        handleForm={getEmailModalData}
        formData={emailModalGetData}
        listData={emailModalList}
        sendAllEmail={sendAllEmail}
        sendReadEmail={sendReadEmail}
      />
      <SMSModal
        showModal={smsModalInd}
        handleClose={showSmsModal}
        data={smsModalData}
        handleSave={saveSmsModal}
        formData={smsModalGetData}
        handleForm={getSmsModalData}
        listData={smsModalList}
        sendAllSms={sendAllSms}
        candidateName={candidateName}
      />
      <CallModal
        showModal={callModalInd}
        handleClose={showCallModal}
        listData={callModalList}
        phoneNumber={callParams.phoneNumber}
        candidateUniqueId={callParams.candidateUniqueId}
        getCallHistoryList={getCallHistoryList}
        jobsClaimId={callParams.jobsClaimId}
        jobsShiftUniqueId={callParams.jobsShiftUniqueId}
      />
      {/* first-row => Shift Title */}
      <div className="row">
        <div className="d-flex">
          <div className="col-6">
            <label className="form-label">Shift Title:</label>
            <label>{jobTitle}</label>
          </div>
        </div>
      </div>
      {/* Second Row => Claimed details*/}
      <div className="row ">
        <div className="d-flex ">
          {/* Claimed By */}
          <div className="col-2">
            <label className="form-label">Claimed By:</label>
            <label>{claimedCandidateInfo?.candidateName}
            </label>
          </div>
          {/* Claimed Date */}
          <div className="col-2">
            <label className="form-label"> Claimed Date:</label>
            <label>
              {claimedCandidateInfo?.claimedDateToDisplay
                ? moment(claimedCandidateInfo?.claimedDateToDisplay).format(
                  "MM/DD/YYYY"
                )
                : ""}
            </label>
          </div>
          {/* Claimed Time */}
          <div className="col-2">
            <label className="form-label">Claimed Time:</label>
            <label>
              {claimedCandidateInfo?.claimedDateToDisplay
                ? moment(claimedCandidateInfo?.claimedDateToDisplay).format(
                  "hh:mm A"
                )
                : ""}
            </label>
          </div>
          <div className="col-2">
            <label className="form-label">Shift Hours:</label>
            <label htmlFor="Location Name">
              {/* {props?.jobDetails?.shiftHours} */}
              {props?.shiftHours ? shiftHoursCalc(props?.shiftHours) : ""}
            </label>
          </div>
          {props?.claimedCandidateInfo?.cellPhoneNumber &&
            <div className="col-2">
              <label className="form-label">Phone number:</label>
              <label htmlFor={props?.claimedCandidateInfo?.cellPhoneNumber}>{props?.claimedCandidateInfo?.cellPhoneNumber} <br/>
              <div style={{display:"flex", alignItems:"center" , columnGap:"0.25rem"}}>
                    <div style={{display: 'inline-block'}}>
                  <span onClick={() => showCallModal(claimedCandidateInfo)} className='connection'>
                  <i
                    class="fe fe-phone-call"
                    style={{
                      color: "#fff",
                      fontWeight: '500',
                      fontSize: '18px'
                    }}
                  ></i>
                </span>
                </div>{" "}
                  <div style={{display: 'inline-block'}}>
                  <span  onClick={() => showSmsModal(claimedCandidateInfo)}  className='connection'>
                  <i
                                class="fa fa fa-commenting-o"
                                style={{ fontSize: '18px', cursor: "pointer", color: "#fff" }}
                              ></i>
                </span>
                </div>
              </div>
                {/* <i className="fa fa-commenting" onClick={() => showSmsModal(claimedCandidateInfo)}  style={{ cursor: 'pointer'}}></i> */}
              </label>
            </div>
          }
          {props?.claimedCandidateInfo?.email &&
            <div className="col-2">
              <label className="form-label">Email:</label>
              <label htmlFor={props?.claimedCandidateInfo?.email} >{props?.claimedCandidateInfo?.email}<br/>
              <div style={{display: "inline-block"}}>
              <span onClick={() => showEmailModal(props?.claimedCandidateInfo)} className='connection'>
              <i
                class="ti-email"
                style={{
                  color: "#fff",
                  fontWeight: '500',
                  fontSize: '18px'
                }}
              ></i>
            </span>
            </div>
              </label>
            </div>
          }
        </div>
      </div>
      {/* Third Row => Shift Date details*/}
      <div className="row ">
        <div className=" d-flex  ">
          <div className="col-2">
            <label className="form-label">Shift Date:</label>
            <label htmlFor="Location Name">{props?.jobDateToDisplay}</label>
          </div>
          <div className="col-2">
            <label className="form-label">Shift End Date:</label>
            <label htmlFor="Location Name">{props?.jobEndDateToDisplay}</label>
          </div>
          <div className="col-2">
            <label className="form-label">Shift Start Time:</label>
            <label htmlFor="Location Name">
              {claimedCandidateInfo?.isClaimed &&
                claimedCandidateInfo?.jobDate
                ? moment(claimedCandidateInfo?.jobDate).format("hh:mm A")
                : props?.shiftStartTime}
            </label>
          </div>
          <div className="col-2">
            <label className="form-label">Shift End Time:</label>
            <label htmlFor="Address">
              {claimedCandidateInfo?.isClaimed &&
                claimedCandidateInfo?.jobEndDate
                ? moment(claimedCandidateInfo?.jobEndDate).format("hh:mm A")
                : props?.shiftEndTime}
            </label>
          </div>
          <div className="col-2">
          <label className="form-label">Department:</label>
            <label htmlFor="departmentDetails">
                        {props?.departmentDetails
                          ?.map((deps) => <p>{deps?.name}</p>)}
                      </label>
          </div>
        </div>
      </div>
      {/* FourthRow => checkIn Details */}
      <div className="row ">
        <div className="d-flex  ">
          <div className="col-2">
            <label className="form-label">Check In Date:</label>
            <label
            // style={{
            //   background: `${
            //     claimedCandidateInfo?.checkInStatus === 2
            //       ? "#ffd300"
            //       : "#fff"
            //   }`,
            // }}
            >
              {claimedCandidateInfo?.checkedInDateToDisplay
                ? moment(
                  claimedCandidateInfo?.checkedInDateToDisplay
                ).format("MM/DD/YYYY")
                : ""}
            </label>
          </div>
          <div className="col-2">
            <ToolTip
              position={"top"}
              value={claimedCandidateInfo?.checkedInDateToolTipToDisplay}
            >
              <div>
                <label style={{ cursor: "pointer" }} className="form-label">
                  Check In Time:
                </label>
                <label
                  style={{
                    background: `${claimedCandidateInfo?.lateCheckedInTime && "#ffd300"
                      }`,
                  }}
                >
                  {claimedCandidateInfo?.checkedInDateToDisplay
                    ? moment(
                      claimedCandidateInfo?.checkedInDateToDisplay
                    ).format("hh:mm A")
                    : ""}{" "}
                  {claimedCandidateInfo?.lateCheckedInTime &&
                    `(${claimedCandidateInfo?.lateCheckedInTime})`}
                </label>
              </div>
            </ToolTip>

          </div>
          <div className="col-2">
            <label className="form-label">Check Out Date:</label>
            <label>
              {claimedCandidateInfo?.checkedOutDateToDisplay
                ? moment(
                  claimedCandidateInfo?.checkedOutDateToDisplay
                ).format("MM/DD/YYYY")
                : ""}
            </label>
          </div>
          <div className="col-2">
            <ToolTip
              position={"top"}
              value={claimedCandidateInfo?.checkedOutDateToolTipToDisplay}
            >
              <div>
                <label style={{ cursor: "pointer" }} className="form-label">
                  Check Out Time:
                </label>
                <label
                  style={{
                    background: `${claimedCandidateInfo?.lateCheckedOutTime && "#ffd300"
                      }`,
                  }}
                >
                  {claimedCandidateInfo?.checkedOutDateToDisplay
                    ? moment(
                      claimedCandidateInfo?.checkedOutDateToDisplay
                    ).format("hh:mm A")
                    : ""}{" "}
                  {claimedCandidateInfo?.lateCheckedOutTime &&
                    `(${claimedCandidateInfo?.lateCheckedOutTime})`}
                </label>
              </div>
            </ToolTip>

          </div>
          <div className="col-2">
            <label className="form-label">Paid Date:</label>
            <label>
              {claimedCandidateInfo?.paidDateToDisplay
                ? moment(claimedCandidateInfo?.paidDateToDisplay).format(
                  "MM/DD/YYYY"
                )
                : ""}
            </label>
          </div>
          <div className="col-2">
            <label className="form-label">Paid Time:</label>
            <label>
              {claimedCandidateInfo?.paidDateToDisplay
                ? moment(claimedCandidateInfo?.paidDateToDisplay).format(
                  "hh:mm A"
                )
                : ""}
            </label>
          </div>
        </div>
      </div>
      {/* FourthRow-2 => PayRate Details */}
      <div className="row ">
        <div className="d-flex  ">
          <div className="col-2">
            <label htmlFor="payRateType" className="form-label">Pay Rate Type:</label>
            <label
            htmlFor={props?.payRateType}
            >
              {(+props?.payRateType === +payRateTypeObj.systemCal) ? "System Payrate" :  (+props?.payRateType === +payRateTypeObj.manualCal) ? "Fixed Payrate":""}
            </label>
          </div>
          {+props?.payRateType === +payRateTypeObj.manualCal ? (
            <div className="col-2">
              <label htmlFor="manualTotalShiftAmountToDisplay" className="form-label">
                Total Shift Amount:
              </label>
              <label htmlFor={props?.manualTotalShiftAmountToDisplay}>
                {props?.manualTotalShiftAmountToDisplay ?? null }
              </label>
            </div>
          ) : (
            ""
          )}
      </div>
      </div>
      {/* FourthRow-3 => OT Details */}
      <div className="row ">
        <div className="d-flex  ">
          <div className="col-2">
              <label htmlFor="straightHoursToDisplay" className="form-label">
                Straight Hours:
              </label>
              <label htmlFor={props?.straightHoursToDisplay}>
                {(+props?.payRateType === +payRateTypeObj.manualCal) ? null : props?.straightHoursToDisplay}
              </label>
            </div>
          <div className="col-2">
              <label htmlFor="straightAmountToDisplay" className="form-label">
              Straight Time Payment Amount:
              </label>
              <label htmlFor={props?.straightAmountToDisplay}>
                {(+props?.payRateType === +payRateTypeObj.manualCal) ? null : props?.straightAmountToDisplay}
              </label>
            </div>
            <div className="col-2">
              <label htmlFor="overtimeHoursToDisplay" className="form-label">
                Overtime Hours:
              </label>
              <label htmlFor={props?.overtimeHoursToDisplay}>
                {(+props?.payRateType === +payRateTypeObj.manualCal) ? null : props?.overtimeHoursToDisplay}
              </label>
            </div>
            <div className="col-2">
              <label htmlFor="overtimeMarkupToDisplay" className="form-label">OT Markup:</label>
              <label
              htmlFor={props?.overtimeMarkupToDisplay}
              >
                {props?.overtimeMarkupToDisplay ?? ""}
              </label>
          </div>
          <div className="col-2">
              <label htmlFor="overtimeAmountToDisplay" className="form-label">
                OT Payment Amount:
              </label>
              <label htmlFor={props?.overtimeAmountToDisplay}>
                { (+props?.payRateType === +payRateTypeObj.manualCal) ? null : props?.overtimeAmountToDisplay}
              </label>
            </div>
      </div>
      </div>
      {/* FifthRow => Candidate BillingRate Details */}
      <div className="d-flex ">
        <div className="col-2">
          <label className="form-label">
            Candidate Work Duration Hours:
          </label>
          <label>{claimedCandidateInfo?.totalworkedHourToDisplay}</label>
        </div>
        <div className="col-2">
          <label className="form-label">Candidate Hourly Base Rate:</label>
          <label>
            {claimedCandidateInfo?.candidateHourlyBaseRateToDisplay}
          </label>
        </div>
        <div className="col-2">
          <label className="form-label">Variable Shift Mark Up:</label>
          <label>
            <span style={{ marginRight: "0.5rem", display: "inline-block" }}>{claimedCandidateInfo?.variableShiftMarkupToDisplay}</span>
            <span  >{(claimedCandidateInfo?.variableShiftMarkupToDisplay === "Variable") ? (
              <ToolTip position={"top"} value={VariablePayRateTable}>
                <i class="fa fa-question-circle" style={{ fontSize: "15px", marginTop: "4px", cursor: "pointer" }} aria-hidden="true"></i>
              </ToolTip>) : ""}</span>
          </label>
        </div>
        <div className="col-2">
          <label className="form-label">Mileage Mark Up:</label>
          <label>{claimedCandidateInfo?.mileageMarkupToDisplay}</label>
        </div>
        <div className="col-2">
          <label className="form-label">Candidate Hourly Pay Rate:</label>
          <label className="d-flex">
            {(claimedCandidateInfo?.candidateHourlyPayrateToDisplay && claimedCandidateInfo?.candidateHourlyPayrateToDisplay !== "Variable") ? `$ ${claimedCandidateInfo?.candidateHourlyPayrateToDisplay}` : claimedCandidateInfo?.candidateHourlyPayrateToDisplay}
            
            
            
            
            
            
            {claimedCandidateInfo?.candidateHourlyPayrateToDisplay === "Variable" ?
            <span className="custom-overlay-view"
            onClick={() => getVariableDetails(claimedCandidateInfo, true)}
            >
             <span className="custom-trigger-view"> 
             <i class="fa fa-question-circle" style={{ fontSize: "15px", marginTop: "4px", cursor: "pointer" }} aria-hidden="true"></i>
             {
              (variableOpen?.status) &&
              <div className="custom-popover-view" id="customPopover">
                <table ref={variableRef} className='table'>
                  <thead>
                    <tr>
                      <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Time</th>
                      <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Rate per hour</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      variableOpen?.data ? 
                      (
                        variableOpen?.data)?.map((item) => (
                          <tr className="bg-white">
                            <td >{item?.variablePayrateTime}</td>
                            <td >{item?.candVariablePayratesAmountToDisplay ? `$ ${item?.candVariablePayratesAmountToDisplay}` : ''}</td>
                          </tr>
                        ))
                      
                      : 
                      
                      '' 
                    }
                  </tbody>
                </table>
              </div>
            }
             </span>
            </span> : ''
             }



          </label>
        </div>

        <div className="col-2">
          <label className="form-label">Candidate Payment Subtotal Amount:</label>
          <label>
            {claimedCandidateInfo?.candidatePaymentSubtotalAmountToDsiplay}
          </label>
        </div>
      </div>
      {/* sixthRow => Incentive Details */}
      <div className="row">
        <div className="d-flex">
          <div className="col-2">
            <label className="form-label">Incentive:</label>
            <label>{props?.incentiveToDisplay}</label>
          </div>
          <div className="col-2">
          <label style={{color:"#16a34a"}} className="form-label">Total Candidate Payment Amount:</label>
          <label>
            {claimedCandidateInfo?.candidateTotalAmountToDisplay}
          </label>
        </div>
          {/* <div className="col-2">
            <label className="form-label">Incentive Mark Up:</label>
            <label>{props?.incentiveMarkupToDisplay ?? ""}</label>
          </div>
          <div className="col-2">
            <label className="form-label">Incentive Billing Amount:</label>
            <label>
              {props?.employerIncentiveToDisplay}
            </label>
          </div> */}
        </div>
      </div>
      {/* seventhRow => Candidate BillingRate Details  */}
      <div className="row">
        <div className="d-flex">
          <div className="col-2">
            <label className="form-label">
              Employer Hourly Base Rate:
            </label>
            <label>
              {(claimedCandidateInfo?.employerHourlyBaseRateToDisplay && claimedCandidateInfo?.employerHourlyBaseRateToDisplay !== "Variable") ? `$ ${claimedCandidateInfo?.employerHourlyBaseRateToDisplay}` : claimedCandidateInfo?.employerHourlyBaseRateToDisplay}
            </label>
          </div>
          <div className="col-2">
            <label className="form-label">Employer Billing Mark Up:</label>
            <label>
              {claimedCandidateInfo?.employerBillingMarkupToDisplay}
            </label>
          </div>
          <div className="col-2">
            <label className="form-label">
              Employer Hourly Billing Rate:
            </label>
            <label>
              {(claimedCandidateInfo?.employerHourlyBillingRateToDisplay && claimedCandidateInfo?.employerHourlyBillingRateToDisplay !== "Variable") ? `$ ${claimedCandidateInfo?.employerHourlyBillingRateToDisplay}` : claimedCandidateInfo?.employerHourlyBillingRateToDisplay}
             
              
              
              
              {claimedCandidateInfo?.candidateHourlyPayrateToDisplay === "Variable" ?
           <span className="custom-overlay-view"
            onClick={() => getVariableDetails(claimedCandidateInfo, false)}
            >
             <span className="custom-trigger-view"> 
             <i class="fa fa-question-circle" style={{ fontSize: "15px", marginTop: "4px", cursor: "pointer" }} aria-hidden="true"></i>
             {
              (variableEmpBaseOpen?.status) &&
              <div className="custom-popover-view" id="customPopover">
                <table ref={variableRef} className='table'>
                  <thead>
                    <tr>
                      <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Time</th>
                      <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Rate per hour</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      variableEmpBaseOpen?.data ? 
                      (
                        variableEmpBaseOpen?.data)?.map((item) => (
                          <tr className="bg-white">
                            <td>{item?.variablePayrateTime}</td>
                            <td >{item?.empVariablePayratesAmountToDisplay ? `$ ${item?.empVariablePayratesAmountToDisplay}` : ''}</td>
                          </tr>
                        ))
                      
                      : 
                      
                      '' 
                    }
                  </tbody>
                </table>
              </div>
            }
             </span>
            </span> : ''
            } 





            </label>
          </div>
          <div className="col-2">
            <label className="form-label">Employer Incentive Mark Up:</label>
            <label>{props?.incentiveMarkupToDisplay ?? ""}</label>
          </div>
          <div className="col-2">
            <label className="form-label">Employer Incentive Billing Amount:</label>
            <label>
              {props?.employerIncentiveToDisplay}
            </label>
          </div>
          <div className="col-2">
            <label style={{color:"#16a34a"}} className="form-label"> Total Employer Billing Amount:</label>
            <label>
              {claimedCandidateInfo?.employerBillAmountToDisplay}
            </label>
          </div>
        </div>
      </div>


        {/* {props?.pageName !== 'awaitingcorrection' ? 
      <div>
      <label className="form-label">Work Break Info:</label>
{ props?.jobBreakDetailsList?.length ?
        <table className="table" style={{width: '800px'}}>
          <thead>
            <tr>
            <th  style={{
                          textTransform: "capitalize",
                          textAlign: "center",
                        }}>Break Type</th>
           <th  style={{
                          textTransform: "capitalize",
                          textAlign: "center",
                        }}>Break Start Date / Time</th>
            <th  style={{
                          textTransform: "capitalize",
                          textAlign: "center",
                        }}>Break End Date / Time</th>
            <th  style={{
                          textTransform: "capitalize",
                          textAlign: "center",
                        }}>Break Duration</th>
            <th  style={{
                          textTransform: "capitalize",
                          textAlign: "center",
                        }}>Paid Time</th>
            </tr>
          </thead>
          <tbody>
            {
              props?.jobBreakDetailsList?.map((item) => (
            <tr>
              <td className="text-center">{item.jobBreakType}</td>
              <td className="text-center">{item?.breakStartDateTime}</td>
              <td className="text-center">{item?.breakEndDateTime}</td>
              <td className="text-center">{item.jobBreakTypeDuration ? `${item.jobBreakTypeDuration} Hours` : ''} </td>
              <td className="text-center">{item.isPaidBreak ? 'Yes' : 'No'}</td>
            </tr>
              ))
            }
            
          </tbody>
        </table> 
         : ''
} 
      </div> : ''} */}
    </>
  );
};

export default SingleShiftClaimInfo;
